<template>
  <!-- TODO  procurar uma forma melhor de ver isso -->
  <div>
    <div v-if="isLoading">Loading...</div>
    <router-view v-else v-c-emit-root-event:update-close-popup></router-view>
  </div>
</template>

<script>
import { productFruits } from 'product-fruits'
import config from '@/utils/configUtil'

export default {
  name: 'App',
  data() {
    return {
      isLoading: false,
    }
  },
  mounted() {
    this.addGoogleTagManagerScript()
    const lang = localStorage.getItem('lang', lang) || 'en-US'
    this.$i18n.locale = lang
    this.configProductFruits()

    this.$root.$on('chooseLang', (value) => {
      this.$i18n.locale = value
      this.$store.commit('UPDATE_LANG', value)
      localStorage.setItem('lang', value)
      this.restartProductFruits()
    })
    // this.$store.dispatch("auth/setOrganizationCurrent")
    // let self = this
    // this.isLoading = true
    // setTimeout(() => {
    //   self.isLoading = false
    // }, 3000)
  },
  methods: {
    async addGoogleTagManagerScript() {
      const configScoped = await config()
      let script = document.createElement('script')

      const gtagScript = (function (w, d, s, l, i) {
        w[l] = w[l] || []
        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != 'dataLayer' ? '&l=' + l : ''
        j.async = true
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
        f.parentNode.insertBefore(j, f)
      })(window, document, 'script', 'dataLayer', configScoped.VUE_APP_GTAG_KEY)

      script.setAttribute('src', gtagScript)
      document.head.appendChild(script)
    },
    async configProductFruits() {
      const configScoped = await config()

      if (!configScoped.VUE_APP_PRODUCT_FRUITS_FLAG) return

      const splittedName = this.$store.state.auth.user?.name?.split(' ')
      const productFruitsLang = this.$store.state.lang.split('-')[0]

      const userId = this.$store.state.auth.user.id
      const userEmail = this.$store.state.auth.session.user?.email
      const userCreatedDateTime = this.$store.state.auth.session.user?.createdDateTime
      const userPlanName = this.$store.state.auth.session.organization?.planName
      const organizationId = this.$route.params.organizationId

      if (!userId || !splittedName) return

      productFruits.init(configScoped.VUE_APP_PRODUCT_FRUITS_ID, productFruitsLang, {
        username: userId,
        firstname: splittedName[0],
        lastname: splittedName[1],
        email: userEmail,
        signUpAt: userCreatedDateTime,
        props: {
          planName: userPlanName,
          organizationId: organizationId,
        },
      })
    },
    async restartProductFruits() {
      const configScoped = await config()
      if (!configScoped.VUE_APP_PRODUCT_FRUITS_FLAG) return

      window.productFruits?.services?.destroy()
      this.configProductFruits()
    },
  },
  computed: {
    authStatus() {
      return this.$store.state.auth.status
    },
  },
  watch: {
    authStatus: {
      handler(newValue) {
        if (newValue == 'success') {
          this.configProductFruits()
        }
      },
      immediate: true,
    },
  },
}
</script>

<style lang="scss">
// Import Main styles for this application
@import 'assets/scss/style';

ul {
  list-style: none;
}

img {
  max-width: 100%;
  height: auto;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.height-enter-active,
.height-leave-active {
  height: auto;
  opacity: 1;
  transition: opacity 200ms ease, height 8s ease-out;
}
.height-enter, .height-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transition: opacity 200ms ease, height 8s ease-out;
  height: 0;
  opacity: 0;
}

.cursor-pointer {
  cursor: pointer;
}

.cursor-not-allowed {
  cursor: not-allowed;
}

.pointer-events-none {
  pointer-events: none;
}

.opacity-50 {
  opacity: 0.5;
}

.w-70 {
  width: 70%;
}

.inputUpload {
  display: flex;
  align-items: center;
  margin-bottom: 0;
  background: var(--white);
  cursor: pointer;
  position: relative;

  &:hover {
    box-shadow: 0px 10px 21px 0 rgba(34, 37, 43, 0.03);
  }

  &--disabled {
    background-color: var(--gray-400);
    cursor: wait;

    .form-group {
      background-color: var(--gray-400);
      cursor: not-allowed;
    }
  }

  label {
    display: flex;
    flex-basis: 1 0;
    position: relative;
    color: var(--gray-600);
    text-align: center;
    cursor: pointer;
    margin-bottom: 0;
    padding: 1em 1em 1em 0;
    margin-right: 10px;
  }

  .form-group {
    display: flex;
    margin: 0;
  }

  .form-control-file {
    display: none !important;
  }
}
.inputUpload__nameFile {
  display: flex;
  align-items: center;
  justify-content: start;
  flex: 1;
}
</style>
